<p-toast></p-toast>
<div class="vendor-associate card">
    <div class="add-vendor-associate-details">
        <form [formGroup]="vendorAssDetailsForm">
            <!-- <marquee class="my-2" behavior="scroll" direction="left" style="color: red; font-weight: bold; font-size: 1rem;">All item price of selected MI-system/ programme is mandatory. Kindly ensure</marquee> -->

            <div class="p-fluid p-formgrid grid mx-2">

                <div class="field col-12 md:col-3">
                    <label htmlFor="selectProgram">{{'WORK_TYPE'| translate}}</label>
                    <div class="grid-item">
                        <p-dropdown [options]="workTypeList" formControlName="workType" optionLabel="Type"
                            placeholder="{{'SELECT_A_WORK_TYPE' | translate}}" appendTo="body">
                        </p-dropdown>
                        <div *ngIf="vendorAssDetailsForm.controls['workType'].invalid && vendorAssDetailsForm.controls['workType'].touched"
                            class="p-error">
                            {{'WORKTYPE_IS_REQUIRED' | translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label for="associateName">{{'ASSOCIATE_NAME' | translate}}</label>
                    <input pInputText formControlName="associateName" id="associateName" type="text"
                        [ngClass]="{ 'ng-invalid ng-dirty': vendorAssDetailsForm.controls['associateName'].invalid && vendorAssDetailsForm.controls['associateName'].touched }" />
                    <div *ngIf="vendorAssDetailsForm.controls['associateName'].invalid && vendorAssDetailsForm.controls['associateName'].touched"
                        class="p-error">
                        {{'ASSOCIATE_NAME_IS_REQUIRED' | translate}}
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label for="aadharNumber">{{'AADHAR_NUMBER' | translate}}</label>
                    <input pInputText formControlName="aadharNumber" id="aadharNumber" type="number"
                        onwheel="this.blur()" maxlength="12" pattern="^[0-9]{12}$"
                        [ngClass]="{ 'ng-invalid ng-dirty': vendorAssDetailsForm.controls['aadharNumber'].invalid && vendorAssDetailsForm.controls['aadharNumber'].touched }" />
                    <div *ngIf="vendorAssDetailsForm.controls['aadharNumber'].invalid && vendorAssDetailsForm.controls['aadharNumber'].touched"
                        class="p-error">
                        <span
                            *ngIf="vendorAssDetailsForm.controls['aadharNumber'].errors?.required">{{'AADHAR_NO_IS_REQUIRED'
                            | translate}}</span>
                        <span
                            *ngIf="vendorAssDetailsForm.controls['aadharNumber'].errors?.minlength || vendorAssDetailsForm.controls['aadharNumber'].errors?.maxlength || vendorAssDetailsForm.controls['aadharNumber'].errors?.pattern">
                            {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' | translate}}
                        </span>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label for="mobileNo">{{'MOBILE_NUMBER' | translate}}</label>
                    <input pInputText formControlName="mobileNo" id="mobileNo" type="number" maxlength="10"
                        onwheel="this.blur()" pattern="^[0-9]{10}$"
                        [ngClass]="{ 'ng-invalid ng-dirty': vendorAssDetailsForm.controls['mobileNo'].invalid && vendorAssDetailsForm.controls['mobileNo'].touched }" />
                    <div *ngIf="vendorAssDetailsForm.controls['mobileNo'].invalid && vendorAssDetailsForm.controls['mobileNo'].touched"
                        class="p-error">
                        <span *ngIf="vendorAssDetailsForm.controls['mobileNo'].errors?.required">{{'MOBILE_NO_IS_REQ'
                            | translate}}</span>
                        <span
                            *ngIf="vendorAssDetailsForm.controls['mobileNo'].errors?.minlength || vendorAssDetailsForm.controls['mobileNo'].errors?.maxlength || vendorAssDetailsForm.controls['mobileNo'].errors?.pattern">
                            {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' | translate}}
                        </span>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="name" class="ml-2">{{ "UPLOAD_PHOTO" | translate }}</label>
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #vendorAssociateUpload (uploadHandler)="
                        onUpload($event, 'photo', vendorAssociateUpload)" name="myfile[]" [maxFileSize]="5000000"
                        [multiple]="false" chooseLabel="{{ 'CHOOSE' | translate }}" [auto]="false"
                        [showCancelButton]="false">
                    </p-fileUpload>
                    <p-image *ngIf="vendorAssDetailsForm.value['photo']" [src]="vendorAssDetailsForm.value['photo']"
                        alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"
                        [preview]="true"></p-image>
                    <div *ngIf="isSubmitted && vendorAssDetailsForm.controls.photo.errors" class="invalid-feedback">
                        <div *ngIf="vendorAssDetailsForm.controls.photo.errors.required">
                            {{ "CHOOSE_AND_UPLOAD_PHOTO" | translate }}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="name" class="ml-2">{{ "UPLOAD_SIGNATURE" | translate }}</label>
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #vendorAssociateUpload1
                        (uploadHandler)="
                        onUpload($event, 'signature', vendorAssociateUpload1)
                      " name="myfile[]" [maxFileSize]="5000000" [multiple]="false"
                        chooseLabel="{{ 'CHOOSE' | translate }}" [auto]="false" [showCancelButton]="false">
                    </p-fileUpload>
                    <p-image *ngIf="vendorAssDetailsForm.value['signature']"
                        [src]="vendorAssDetailsForm.value['signature']" alt="Image" width="60" [preview]="true"
                        class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
                    <div *ngIf="isSubmitted && vendorAssDetailsForm.controls.signature.errors" class="invalid-feedback">
                        <div *ngIf="vendorAssDetailsForm.controls.signature.errors.required">
                            {{ "CHOOSE_AND_UPLOAD_SIGNATURE" | translate }}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-2">
                    <label></label>
                    <div class="grid-item mt-1">
                        <button pButton pRipple type="submit" label="{{'SUBMIT' | translate}}"
                            (click)="addVendorAssociate()" class="p-button-success mt-2"
                            style="min-width: 90px; width: auto; height: 32px;">
                        </button>
                    </div>
                </div>

                <!-- <div class="field col-12 md:col-2">
                    <label></label>
                    <div class="grid-item mt-1">
                        <button pButton pRipple type="submit" icon="pi pi-plus" label="{{'Submit'| translate}}"
                            (click)="addVendorAssociate()" class="p-button-success mt-2 ml-5"
                            style="width: 90px; height: 32px; align-items: center;">
                        </button>
                    </div>
                </div> -->

            </div>
        </form>
    </div>
</div>

<div class="card mt-2 dashboardTable" *ngIf="addedAssList.length > 0">
    <p-table #addedCompTable [value]="addedAssList" [rows]="10" [paginator]="true" responsiveLayout="scroll"
        [rowHover]="true" dataKey="Mobile"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}"
        [globalFilterFields]="[
        'Name', 
        'AadharNo', 
        'Mobile', 
        'WorkType', 
        'Photo', 
        'Signature', 
    ]">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <!-- Left side -->
                <div class="col-5 flex justify-content-start">
                    <h5 [ngStyle]="{ 'font-weight': 'bold','display': 'flex', 'justify-content': 'space-around' }">
                        {{ "Added Associate Details" | translate }}
                    </h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-3 d-flex justify-content-between">
                    <p-splitButton [model]="menuItems" icon="pi pi-download" label="{{'EXPORT' | translate}}"></p-splitButton>
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button> -->
                    <!-- <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button> -->
                    <!-- <p-menu #menu [popup]="true" [model]="addedCompTableExport"></p-menu> -->
                </div>
                <!-- Right side for search -->
                <div class="col-4 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="addedCompTable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <!-- <th pSortableColumn="VendorAssociateId">{{'Associate Id'| translate}}</th> -->
                <th pSortableColumn="Name">{{'NAME'| translate}}</th>
                <th pSortableColumn="AadharNo">{{'AADHAR_NO'| translate}}</th>
                <th pSortableColumn="Mobile">{{'MOBILE_NO'| translate}}</th>
                <th pSortableColumn="WorkType">{{'WORK_TYPE'| translate}}</th>
                <th>{{'PHOTO'| translate}}</th>
                <th>{{'SIGNATURE'| translate}}</th>
                <th>{{'ACTIONS'| translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-Index="rowIndex">
            <tr class="body-section" [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(rowData)}">
                <!-- <td>{{ Index + 1 }}</td> -->
                <!-- <td>{{rowData?.VendorAssociateId}}</td> -->
                <td>{{rowData?.Name}}</td>
                <td>{{rowData?.AadharNo}}</td>
                <td>{{rowData?.Mobile}}</td>
                <td>{{rowData?.WorkType}}</td>
                <td>
                    <a *ngIf="rowData?.Photo && rowData?.Photo != 'string'"
                        style="cursor: pointer" icon="pi pi-eye" [href]="rowData?.Photo"
                        target="_blank">
                        <button pButton type="button"
                            class="p-button-rounded p-button-accent p-button-secondary p-button-rounded" pTooltip="View"
                            icon="pi pi-eye"></button>
                    </a>
                </td>
                <td>
                    <a *ngIf="rowData?.Signature && rowData?.Signature != 'string'"
                        style="cursor: pointer" icon="pi pi-eye" [href]="rowData?.Signature"
                        target="_blank">
                        <button pButton type="button"
                            class="p-button-rounded p-button-accent p-button-secondary p-button-rounded" pTooltip="View"
                            icon="pi pi-eye"></button>
                    </a>
                </td>
                <td>
                    <button *ngIf="rowData?.ApprovalStatus == 'Pending'" pButton pRipple type="button" icon="pi pi-trash"
                        (click)="onDeleteAddedAssRow(rowData)"
                        class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="footer">

        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex  justify-content-between flex-column ">
                <!-- <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{appVerificationModel ? appVerificationModel.length : 0 }}
                    {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                </p> -->
                <div class="flex  justify-content-between flex-column ">
                    <div class="flex">
                        <div
                            style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                        </div>{{'PENDING'| translate}}
                    </div>
                    <div class="flex">
                        <div
                            style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                        </div>{{'APROVED'| translate}}
                    </div>
                </div>
            </div>
        </ng-template>

    </p-table>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>